import AmexResyValue, { ComponentAmexResyValueUnderTest } from './AmexResyValue';

export default AmexResyValue;

export { ComponentAmexResyValueUnderTest };
